export default function FilterDetector($window) {
    'ngInject';

    let currentWinSize;
    this.getWindowWidth = function(sizeHandler) {
        const sizeWindow = function() {
            currentWinSize = $window.innerWidth;
            const statusFilterOptions = (currentWinSize >= 1200);
            sizeHandler(statusFilterOptions);
        };
        sizeWindow();
        $window.addEventListener('resize', sizeWindow);
    };
}



// WEBPACK FOOTER //
// ./src/app/services/filterDetector.js